import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

type Props = {
  current: number;
  threshold: number;
};

type Band = 'green' | 'yellow' | 'red';

function bandFor(ratio: number): Band {
  if (ratio >= 0.8) return 'red';
  if (ratio >= 0.6) return 'yellow';
  return 'green';
}

const bandColor: Record<Band, string> = {
  green: '#2e7d32',
  yellow: '#ed6c02',
  red: '#d32f2f',
};

export function UsageProgressBar({ current, threshold }: Props) {
  const safeThreshold = threshold > 0 ? threshold : 1;
  const ratio = Math.min(current / safeThreshold, 1);
  const band = bandFor(ratio);

  return (
    <Box data-color-band={band} sx={{ width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={ratio * 100}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: '#eeeeee',
          '& .MuiLinearProgress-bar': { backgroundColor: bandColor[band] },
        }}
      />
      <Typography variant="caption">
        {current} / {threshold} rentals
      </Typography>
    </Box>
  );
}
